"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetLibrary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const asset_1 = require("@src/types/asset");
const elements_1 = require("@src/components/elements");
const useConfig_1 = require("@src/hooks/useConfig");
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const Api = __importStar(require("@src/api"));
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
const react_intl_1 = require("react-intl");
const AssetLibrary_style_1 = require("./AssetLibrary.style");
const AssetCard_1 = require("./AssetCard");
const AssetUpload_1 = require("./AssetUpload");
const AssetDetailModal_1 = require("./AssetDetailModal");
const AssetLibraryHeader_1 = require("./AssetLibraryHeader");
const use_asset_upload_1 = require("./use-asset-upload");
const UploadingAssetCard_1 = require("./UploadingAssetCard");
const use_asset_library_notifications_1 = require("./use-asset-library-notifications");
const use_asset_download_1 = require("./use-asset-download");
const asset_library_model_1 = require("./asset-library.model");
exports.AssetLibrary = react_1.default.forwardRef(({ isInSelectMode, allowSingleAssetSelectionOnly, areDocumentsDisabled, onAssetsDelete, showSelectedAssetOrder, }, ref) => {
    const config = (0, useConfig_1.useConfig)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const [selectedAssetIds, setSelectedAssetIds] = react_1.default.useState([]);
    const [filteredAssetType, setFilteredAssetType] = react_1.default.useState('ALL');
    const [selectedAssetIdForDetailView, setSelectedAssetIdForDetailView] = react_1.default.useState(null);
    const { showAssetsSuccessfullyDeletedNotification } = (0, use_asset_library_notifications_1.useAssetLibraryNotifications)();
    const { data: { assets, activeAssetCount } = { assets: [], activeAssetCount: 0 }, isLoading: isFetchingAssets, refetch, } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getMyAssets, async () => {
        const queriedAssetType = filteredAssetType === 'ALL' ? null : filteredAssetType;
        const { assets: fetchedAssets, activeAssetCount: fetchedActiveAssetCount } = await Api.Asset.getMyAssets(queriedAssetType);
        return { assets: fetchedAssets, activeAssetCount: fetchedActiveAssetCount };
    });
    const deselectAllAssets = () => {
        setSelectedAssetIds([]);
    };
    react_1.default.useEffect(() => {
        refetch();
        deselectAllAssets();
    }, [filteredAssetType]);
    const { mutateAsync: deleteAssets, isLoading: isDeletingAssets } = (0, useAppMutation_1.useAppMutation)(Api.Asset.softDeleteAssets, {
        onSuccess: (_, removedAssetIds) => {
            queryClient.setQueryData(queries_1.Queries.getMyAssets, ({ assets: currentAssets, activeAssetCount: currentActiveAssetCount }) => ({
                assets: currentAssets.filter((asset) => !removedAssetIds.includes(asset.id)),
                activeAssetCount: currentActiveAssetCount - removedAssetIds.length,
            }));
            deselectAllAssets();
            showAssetsSuccessfullyDeletedNotification(removedAssetIds.length);
            if (onAssetsDelete) {
                onAssetsDelete(removedAssetIds);
            }
        },
    });
    const setVideoAssetIsProcessed = (targetMuxAssetId) => {
        if (!targetMuxAssetId) {
            return;
        }
        queryClient.setQueryData(queries_1.Queries.getMyAssets, ({ assets: currentAssets, activeAssetCount: currentActiveAssetCount }) => ({
            assets: currentAssets.map((asset) => asset.muxAssetId === targetMuxAssetId ? { ...asset, isProcessing: false } : asset),
            activeAssetCount: currentActiveAssetCount,
        }));
    };
    const deleteAssetLocally = (targetAssetId) => {
        queryClient.setQueryData(queries_1.Queries.getMyAssets, ({ assets: currentAssets, activeAssetCount: currentActiveAssetCount }) => ({
            assets: currentAssets.filter((asset) => asset.id !== targetAssetId),
            activeAssetCount: currentActiveAssetCount,
        }));
    };
    const isAssetCountLimitReached = activeAssetCount >= config.assets.countLimit;
    const addAssetIdToSelection = (assetId) => {
        const isAssetAlreadySelected = selectedAssetIds.includes(assetId);
        if (!isAssetAlreadySelected) {
            if (allowSingleAssetSelectionOnly) {
                setSelectedAssetIds([assetId]);
            }
            else {
                setSelectedAssetIds(currSelectedAssetIds => [...currSelectedAssetIds, assetId]);
            }
        }
    };
    const onUploadAssetSuccess = (savedAsset) => {
        if (filteredAssetType === 'ALL' || savedAsset.type === filteredAssetType) {
            queryClient.setQueryData(queries_1.Queries.getMyAssets, ({ assets: currentAssets, activeAssetCount: fetchedActiveAssetCount }) => ({
                assets: [...currentAssets, savedAsset],
                activeAssetCount: fetchedActiveAssetCount + 1,
            }));
            const shouldSelectAssetAfterUpload = Boolean(isInSelectMode && !(savedAsset.type === asset_1.AssetType.DOCUMENT && areDocumentsDisabled));
            if (shouldSelectAssetAfterUpload) {
                addAssetIdToSelection(savedAsset.id);
            }
        }
    };
    const { enqueueAssetFileForUpload, uploadingAssets } = (0, use_asset_upload_1.useAssetUpload)({
        activeAssetCount,
        onUploadAssetSuccess,
    });
    const { downloadAndSaveAssets, isDownloadingAssets } = (0, use_asset_download_1.useAssetDownload)();
    const enqueueAssetFilesIfNotFetching = (files) => {
        if (!isFetchingAssets) {
            files.forEach(enqueueAssetFileForUpload);
        }
    };
    const toggleAssetSelect = (assetId) => {
        const isAssetAlreadySelected = selectedAssetIds.includes(assetId);
        if (isAssetAlreadySelected) {
            const filteredAssetById = selectedAssetIds.filter(assId => assId !== assetId);
            setSelectedAssetIds(filteredAssetById);
            return;
        }
        const newSelectedAssetIds = allowSingleAssetSelectionOnly ? [assetId] : [...selectedAssetIds, assetId];
        setSelectedAssetIds(newSelectedAssetIds);
    };
    const showAssetDetail = (assetId) => {
        setSelectedAssetIdForDetailView(assetId);
    };
    const closeAssetDetailModel = () => {
        setSelectedAssetIdForDetailView(null);
    };
    const selectedAssets = selectedAssetIds.map(id => assets.find(asset => asset.id === id));
    react_1.default.useImperativeHandle(ref, () => ({
        getSelectedAssets: () => selectedAssets,
        setSelectedAssetIds: (assetIds) => setSelectedAssetIds(assetIds.filter(assetId => Boolean(assets.find(ass => ass.id === assetId)))),
    }));
    const isSelectedProcessingVideoAsset = selectedAssetIds.some(assetId => {
        const asset = assets.find(({ id }) => assetId === id);
        return asset && asset.type === asset_1.AssetType.VIDEO && asset.isProcessing;
    });
    return ((0, jsx_runtime_1.jsx)(elements_1.FileDropzone, { onDrop: enqueueAssetFilesIfNotFetching, children: (0, jsx_runtime_1.jsxs)(elements_1.Panel, { className: "p-m", children: [(0, jsx_runtime_1.jsx)(AssetLibraryHeader_1.AssetLibraryHeader, { displayedAssetCount: assets.length, selectedAssetIdsCount: selectedAssetIds.length, filteredAssetType: filteredAssetType, setFilteredAssetType: setFilteredAssetType, enqueueAssetFileForUpload: enqueueAssetFileForUpload, isUploadDisabled: isAssetCountLimitReached || isFetchingAssets, activeAssetCount: activeAssetCount, deleteSelectedAssets: () => deleteAssets(selectedAssetIds), downloadAndSaveSelectedAssets: () => downloadAndSaveAssets(selectedAssets), isSelectedProcessingVideoAsset: isSelectedProcessingVideoAsset, isDownloadingAssets: isDownloadingAssets, isDeletingAssets: isDeletingAssets, deselectAllAssets: deselectAllAssets }), allowSingleAssetSelectionOnly && ((0, jsx_runtime_1.jsx)(elements_1.Alert, { message: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "assets.only_one_asset_message" }), showIcon: true, type: "info", className: "m-b-l flex-inline" })), (0, jsx_runtime_1.jsxs)(AssetLibrary_style_1.AssetsContainer, { shouldBeScrollable: Boolean(isInSelectMode), children: [isFetchingAssets && ((0, jsx_runtime_1.jsx)(AssetLibrary_style_1.SpinnerContainer, { children: (0, jsx_runtime_1.jsx)(elements_1.Spinner, {}) })), !isFetchingAssets && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [uploadingAssets
                                    .map(asset => ({ ...asset, uploadStartedAt: new Date(asset.uploadStartedAt) }))
                                    .sort((0, asset_library_model_1.getAssetsSorterFunc)(Boolean(areDocumentsDisabled)))
                                    .map(uploadingAsset => ((0, jsx_runtime_1.jsx)(UploadingAssetCard_1.UploadingAssetCard, { uploadingAsset: uploadingAsset }, uploadingAsset.uuid))), assets
                                    .map(asset => ({ ...asset, createdAt: new Date(asset.createdAt) }))
                                    .sort((0, asset_library_model_1.getAssetsSorterFunc)(Boolean(areDocumentsDisabled)))
                                    .map(asset => ((0, jsx_runtime_1.jsx)(AssetCard_1.AssetCard, { asset: asset, selectedOrderIndex: showSelectedAssetOrder
                                        ? selectedAssetIds.findIndex(assetId => assetId === asset.id)
                                        : undefined, isAtLeastOneAssetCardSelected: selectedAssetIds.length > 0, isSelected: selectedAssetIds.includes(asset.id), forceShowCheckCircle: Boolean(isInSelectMode), isSelectingDisabled: isDeletingAssets ||
                                        isDownloadingAssets ||
                                        Boolean(areDocumentsDisabled && asset.type === asset_1.AssetType.DOCUMENT), onAssetSelectToggle: () => toggleAssetSelect(asset.id), showAssetDetail: () => showAssetDetail(asset.id), setVideoAssetIsProcessed: () => setVideoAssetIsProcessed(asset.muxAssetId), deleteAssetLocally: () => deleteAssetLocally(asset.id) }, asset.id))), !isAssetCountLimitReached && ((0, jsx_runtime_1.jsx)(AssetUpload_1.AssetUpload, { enqueueAssetFileForUpload: enqueueAssetFileForUpload }))] }))] }), (0, jsx_runtime_1.jsx)(AssetDetailModal_1.AssetDetailModal, { asset: assets.find(asset => asset.id === selectedAssetIdForDetailView), isVisible: selectedAssetIdForDetailView !== null, isDownloadingAssets: isDownloadingAssets, isDeletingAssets: isDeletingAssets, closeAssetDetailModel: closeAssetDetailModel, deleteAsset: () => deleteAssets(selectedAssetIdForDetailView ? [selectedAssetIdForDetailView] : []), downloadAndSaveAsset: () => downloadAndSaveAssets(assets.filter(asset => asset.id === selectedAssetIdForDetailView)) })] }) }));
});
